import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CmsServiceService } from 'src/app/services/cms_services/cms-service.service';
import { ConfigService } from 'src/app/services/config_services/config.service';
import { StmgService } from 'src/app/services/state_Management/stmg.service';

@Component({
  selector: 'app-main-slider',
  templateUrl: './main-slider.component.html',
  styleUrls: ['./main-slider.component.scss'],
})
export class MainSliderComponent implements OnInit {

  banners:any=[];
  bannersPic:any=[];
  noBanner:boolean=true;
  defaultBanner: any;
  showContent: boolean=true;
  isLoading = true;
  
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 10,
    autoplaySpeed: 2500,
    autoplay: true,
    autoplayTimeout: 5000,
    //smartSpeed: 1200, // Smooth transition
    autoplayHoverPause: true,
    navText: ['<', '>'],
    autoWidth:true,
    // margin:10,
    items:1,
    nav: false,
  }

  constructor(
    public config: ConfigService,public stmgService:StmgService,
    public cmsService:CmsServiceService
  ) { }

  reload:boolean;
  
  slide(e:any){
    this.reload=false
    
    setTimeout(() => {
        this.reload=true
    }, 1000);
  }

  ngOnInit(): void {

    this.cmsService.get_home_banners().subscribe({
      next:(res:any)=>{
        const mapped = Object.keys(res).map(key => ({ type: key, value: res[key] }));
        mapped.pop()
        this.banners=mapped
        this.stmgService.updatehomeBanners(this.banners)
        
        if(this.banners[0].value.show == true){
          this.showContent =true
        }else{
          this.showContent =false
        }

        if(this.banners.length==0) {
          this.noBanner = true;
        }else{
          this.noBanner = false;
        }
        //console.log(this.banners[0].value.show);
        this.isLoading = false;
        this.reload = true;
      },
      error:(err)=>{
        if(this.banners.length==0) {
          this.defaultBanner = this.config.getDefaultBanner();
          this.noBanner = true
        }
        this.isLoading = false;
      }
    })

    // this.stmgService.homeBanners_obs.subscribe(msg=>{
    //   if(msg!=''){
    //     this.banners=msg
    //     if(this.banners[0].value.show == true){
    //       this.showContent =true
    //     }else{
    //       this.showContent =false
    //     }
    //     if(this.banners.length==0) {
    //       this.noBanner = true;
    //     }else{
    //       this.noBanner = false;
    //     }

    //     this.isLoading = false;
    //   }else{
    //     this.cmsService.get_home_banners().subscribe({
    //       next:(res:any)=>{
    //         const mapped = Object.keys(res).map(key => ({ type: key, value: res[key] }));
    //         mapped.pop()
    //         this.banners=mapped
    //         this.stmgService.updatehomeBanners(this.banners)
            
    //         if(this.banners[0].value.show == true){
    //           this.showContent =true
    //         }else{
    //           this.showContent =false
    //         }

    //         if(this.banners.length==0) {
    //           this.noBanner = true;
    //         }else{
    //           this.noBanner = false;
    //         }
    //         //console.log(this.banners[0].value.show);
    //         this.isLoading = false;
    //       },
    //       error:(err)=>{
    //         if(this.banners.length==0) {
    //           this.defaultBanner = this.config.getDefaultBanner();
    //           this.noBanner = true
    //         }
    //         this.isLoading = false;
    //       }
    //     })
    //   }
    // })  

    
    //show defualt image
    this.defaultBanner = this.config.getDefaultBanner();
   //console.log(this.defaultBanner,"Banner")
  }

}
